import React from "react";
import cn from "./helpers/cn";

interface TableContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  component?: React.ElementType;
  children?: React.ReactNode;
}

const TableContainer = React.forwardRef<HTMLDivElement, TableContainerProps>((props, ref) => {
  const { className, component: Component = "div", ...other } = props;

  return (
    <Component
      ref={ref}
      className={cn("w-full overflow-x-auto", className)}
      {...other}
    />
  );
});

TableContainer.displayName = "TableContainer";

export default TableContainer;
